module.exports = __webpack_public_path__ + "static/media/Shox 02 BG.b316946a.png";